import React from "react";
import Icon from '@mdi/react';
import { mdiAlertOctagonOutline } from '@mdi/js';
import { RoundStarIcon } from "../custom_icons";

// Any of these Icons work https://pictogrammers.com/library/mdi/

const NewIcon = ({ path, className, size, style }) => {
    switch (path) {
        case "RoundStarIcon":
            return <RoundStarIcon className={className} style={{ ...style, fontSize: size * 15 + "pt" }} />;
        case "":
            return <Icon path={mdiAlertOctagonOutline} size={size}></Icon>;
        default:
            return <Icon path={path} size={size}></Icon>;  // or return a default icon if desired
    }
};

const CustomIcon = ({ className = "", path = "", size = 1, style }) => {
    return (
        <NewIcon path={path} className={className} size={size} style={style} />
    );
};

export default CustomIcon;
export { CustomIcon };
